import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import store from '../store';
import { CurrencyProvider } from '../components/currency';
import AnalyticsProvider from '../components/analytics/AnalyticsProvider';

import SignupFunnelCollection from '../components/signup-collection/SignupFunnelCollection';

const signupCollection = document.getElementById('signup-collection');
if (signupCollection) {
    createRoot(signupCollection).render(
        <Provider store={store}>
            <CurrencyProvider>
                <AnalyticsProvider>
                    <SignupFunnelCollection />
                </AnalyticsProvider>
            </CurrencyProvider>
        </Provider>
    );
}
